import {ProcessStageAutocomplete} from '@hconnect/common/components'
import {ControlledFormField, FormFieldBase} from '@hconnect/common/types'
import {Controller, FieldValues} from 'react-hook-form'

type Props<TField extends FieldValues> = FormFieldBase &
  ControlledFormField<TField> & {
    plantId: string
    onChange?: (value: string | undefined) => void
  }

export const ProcessStageSearchField = <TField extends FieldValues>(props: Props<TField>) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      disabled={props.disabled || props.readOnly}
      render={({field, fieldState}) => (
        <ProcessStageAutocomplete
          plantId={props.plantId}
          label={props.label}
          value={field.value}
          required={!props.optional}
          onChange={(value) => {
            field.onChange(value)
            props.onChange?.(value)
          }}
          errorText={fieldState.error?.message}
          disabled={props.disabled}
        />
      )}
    />
  )
}
